import {ReportRequest} from './report-request.model';
import {SummedMasterReport} from './summed-master-report.model';
export class ReportResponse {
  request: ReportRequest;
  total: SummedMasterReport;
  adUnits?: SummedMasterReport[];
  publishers?: SummedMasterReport[];
  sites?: SummedMasterReport[];
  days: SummedMasterReport[];
  report: SummedMasterReport[];
  request_type: String;
}
